import { resetRefund, updateRefund } from "./actions";

const initialRefundState = {
  ticketNumber: "",
  modificationInfo: null,
  isPublic: null,
};

export const refundSlice = (set, get) => ({
  ...initialRefundState,
});

export const refundActions = (set, get) => ({
  [resetRefund]: () => {
    set((state) => ({
      ...state,
      refund: {
        ...initialRefundState,
      },
    }));
  },
  [updateRefund]: (payload) => {
    set((state) => ({
      ...state,
      refund: {
        ...state.refund,
        ...payload,
      },
    }));
  },
});
